import {until} from 'lit-html/directives/until';
import '@modules/group-filters';
import {addClasses, searchLabels} from '../i18n-labels';
import emsDropdownStyles from './ems-dropdown.css';
import {wrapUnsafeHtml} from "@modules/wrap-unsafe-html";

const getClassDropdownContent = (ctx, html) => {
  const returnHtml = [];
  if (ctx.classSearchResponse.results?.length) {
    ctx.classSearchResponse.results.map((result) => {
      if (ctx.groupsToHide.indexOf(result.id) === -1) {
        returnHtml.push(
          html`
            <button type="button" class="btn dropdown-item" @click="${() => ctx.addClass(result)}">
              ${result.name}
            </button>`
        );
      }
    });
    if (ctx.classSearchResponse.has_more) {
      returnHtml.push(
        html`
          <div class="px-4 text-muted border-dashed-top h5 font-weight-normal pt-3">
            ${until(searchLabels.showingFirstOfAmount(ctx.classSearchLimit))}
          </div>`
      );
    }
  }
  if (!returnHtml.length) {
    returnHtml.push(html`<div class="px-4 h5 font-weight-normal pt-3">${until(searchLabels.NO_MATCHING_RESULTS)}</div>`);
  }
  return returnHtml;
};

const classSectionHeader = (ctx, html, classes, schoolId) => {
  if (!schoolId) {
    return;
  }
  return html`
    <div class="row mt-4">
      <div class="col-8 d-flex align-items-center">
        <div class="pl-4">
          ${breadCrumbs(ctx, html, ctx.data.groupInfo[schoolId]?.split_path || [])}
        </div>
      </div>
      ${!ctx.data.disabled && !ctx.isTeacher ? html`
        <div class="col-4 text-right">
          <ems-dropdown class="mb-3 ${ctx['full-width'] ? 'full-width' : ''}" .styles="${[emsDropdownStyles]}">
            <button type="button" slot="dropdown-toggle"
                    class="btn btn-outline-light d-flex justify-content-between ${ctx['full-width'] ? 'w-100 justify-content-between' : ''}"
                    @click="${() => ctx.getSiblingClasses(classes[0])}">
              <span class="pr-3 d-inline-block">
                ${until(wrapUnsafeHtml(addClasses()))}
              </span>
              <span class="ai ai-chevron-down"></span>
            </button>
            <div slot="dropdown-menu" class="dropdown-menu m-0 w-100 px-2">
              <object-search-form
                class="border-dashed-bottom"
                @on-search="${(e) => ctx.triggerSearch(e, classes[0])}"
                .placeholder="${until(ctx.i18n.__('<tt-ZxbAhFjC>', 'Search Classes'))}"
                .column-layout="${true}"
                reset-text="Reset"></object-search-form>
              ${ctx.loading ?
                 html`<loading-ellipses></loading-ellipses>` :
                 getClassDropdownContent(ctx, html)
               }
            </div>
          </ems-dropdown>
        </div>` :
          '' }
    </div>
  `;
};

const schoolCard = (classes, schoolId, ctx, html) => html`
${classSectionHeader(ctx, html, classes, schoolId)}
<div class="card mb-5 border-top-0 border-bottom-0 border-right-0 card-border-color-left card-border-color-warning w-100 shadow-sm">
  <div class="card-header">
    <span class="heading font-weight-normal">${until(ctx._r(ctx.__('<tt-H7WgoAbb>', 'Classes (%r1%):'), classes?.length ? classes.length : ctx.isTeacher && ctx.groupName ? 1 : 0))}</span>
    ${!ctx.data.disabled && !ctx.isTeacher ? html`<button type="button" class="close f-right p-0" aria-label="Close" @click="${() => ctx.removeClasses(classes)}">
      <span class="ai ai-close-icon"></span>
    </button>` : ''}
  </div>
  <div class="card-body mb-3">
  <div class="card-body mb-3">
    <ul class="row list-unstyled">
      ${classes?.map((classInfo) => html`
        <li class="col-4 mb-2">
          <div class="py-3 pl-2 border class-info">
            <div tabindex="0" class="d-inline-block align-top cursor-pointer text-primary"
                 @click="${() => ctx.classClicked({classInfo})}"
                 role="button" type="button"
                 @keypress="${(e) => (e.key === 'Enter') ? ctx.classClicked({classInfo}): null}"
            >
              ${classInfo.name}
            </div>
            <div class="d-inline-block align-top">
              ${!ctx.data.disabled && !ctx.isTeacher ? html`
                <button type="button" class="close f-right p-2" aria-label="Close Button"
                        @click="${() => ctx.removeClass(classInfo)}"
                        @keypress="${(e) => (e.key === 'Enter') ? ctx.removeClass({classInfo}): null}"
                >
                  <span class="ai ai-close-icon"></span>
                </button>
              ` : ``}
            </div>
          </div>
        </li>
      `)}
      ${classes.length === 0 && ctx.groupName && ctx.isTeacher ? html`
        <div class="col-4 mb-2">
        <li class="py-3 pl-2 border class-info">
          <div class="d-inline-block align-top">
            ${ctx.groupName}
          </div>
        </li>` : ``}
    </ul>
    ${!ctx.data.disabled && !ctx.isTeacher ? html`<p class="text-center mb-0 pb-0"><small>${until(ctx.__('<tt-IovcdUpR>', 'Tap the X next to a class name to remove it.'))}</small></p>` : ''}
  </div>
</div>
`;

const breadCrumbs = (ctx, html, pathArray) => {
  if (!Object.keys(ctx.data.groupInfo || {}).length) {
    return;
  }

  const breadCrumb = [];
  pathArray.map((id) => {
    breadCrumb.push(ctx.data.groupInfo[id].name);
  });

  return breadCrumb.map((name, index) => html`<span class="mr-3 font-size-bigger">
    ${name}</span>
    ${(index === (breadCrumb.length - 1)) ?
      html`` :
      html`<span class="mr-3 font-size-bigger">/</span>`}`);
};

function* withDividers(html, itemsByKey, cb) {
  let index = 0;
  const schoolCount = Object.keys(itemsByKey).length;
  for (const [schoolId, items] of Object.entries(itemsByKey)) {
    yield cb(items, schoolId);
    if (index !== (schoolCount.length - 1)) {
      yield html`<hr>`;
    }
    index += 1;
  }
}


export default (ctx, html) => html`
  ${ctx.data?.addNewSchool ?
      html`
        <group-filters @group-change=${ctx.onGroupSelect}
                       .selected-groups="${ctx.selectedGroupIds}"
                       .showThirdPartyConnected="${false}"
                       class="my-3"></group-filters>
        ${schoolCard([], null, ctx, html)}
      ` :
      html``}
  ${withDividers(html, ctx.data.classesBySchool, (classes, schoolId) => schoolCard(classes, schoolId, ctx, html))}
`;
